import styled from 'styled-components'

import { grayDark, hexRgba, transition } from '../../../../utils/style-utils'

interface Props {
  src?: string
  hover?: boolean
}

export const ImageWrapper = styled.div<Props>`
  width: 100%;
  padding-top: 67%;
  background-color: ${hexRgba(grayDark, 0.5)};
  background-size: cover;
  background-position: center;
  ${(p) => (p.src ? `background-image: url(${p.src});` : '')}
  transform: ${(p) => (p.hover ? 'scale(1.1)' : 'scale(1.01)')};
  ${transition('transform', 0.3)}
`
